import { businessOnlinePaymentStatus } from '@planity/helpers';

export const OnlineBusinessStatus = ({ business, children }) => {
	const status = businessOnlinePaymentStatus(business);
	return children({ status });
};
